module.exports = __webpack_public_path__ + "fonts/OpenSans-Light.d8ba00bc.eot";